export const normalizeText = (text: string): string => {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
};

export const isSubtextAtBeginningOfText = (subtext: string, text: string): boolean => {
    return normalizeText(text).startsWith(normalizeText(subtext));
};

export const formatPrice = (price: string): string => {
    return Number.parseFloat(price).toFixed(2);
};

export function getHtmlContent(html: string) {
    const div = document.createElement('div')
    div.innerHTML = html
    if (div.textContent?.trim() === '') {
        return ''
    }
    const links = div.querySelectorAll('a')
    links.forEach(link => link.target = "_blank")
    return div.innerHTML
}
